import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import socialLinks from '../config/socialLinks';

export default function Footer({ compact=false }){
  return (
    <footer className={`footer-dark${compact ? ' footer-compact' : ''}`}>
      <div className="footer-bg-img" style={{ backgroundImage: "url('/images/footerbg.png')" }} aria-hidden="true" />
      <div className="container">
        <div className="row gy-4 gx-5 footer-main-row">
          <div className="col-lg-4 col-md-6 footer-left">
            <div className="footer-brand">
              <img src="/images/logo.png" alt="SocialManiacs Logo" className="logo-footer" />
            </div> 
          </div>
          <div className="col-lg-2 col-md-3 col-6 footer-links">
            <h6 className="fw-bold">Services</h6>
            <ul className="mt-2">
              <li><Link to="/services">Social Media Management</Link></li>
              <li><Link to="/services">Graphics Designing</Link></li>
              <li><Link to="/services">Video Production</Link></li>
              <li><Link to="/services">Brand Strategy</Link></li>
              <li><Link to="/services">Offline Marketing Collaterals</Link></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 col-6 footer-links">
            <h6 className="fw-bold">Company</h6>
            <ul className="mt-2">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-6 footer-right">
            <h6 className="fw-bold">Get in Touch</h6>
            <div className="footer-contact text-start">
              <div className="d-flex align-items-start justify-content-start mb-2">
                <i className="bi bi-telephone"></i>
                <a href="tel:+918401623480" className="text-decoration-none">+91 84016 23480</a>
              </div>
              <div className="d-flex align-items-start justify-content-start mb-2">
                <i className="bi bi-geo-alt"></i>
                <a
                  href="https://www.google.com/maps?q=212%2C%20kalp%20Business%20Hub%2C%20Karelibaugh%2C%20Vadodara"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  212, Kalp Business Hub,<br/>Karelibaugh, Vadodara
                </a>
              </div>
              <div className="d-flex align-items-start justify-content-start gap-1">
                <i className="bi bi-envelope"></i>
                <a href="mailto:office.socialmaniacs@gmail.com" className="text-decoration-none">office.socialmaniacs@gmail.com</a>
              </div>
            </div>
          </div>
        </div>

        {/* Centered social icons bar */}
        <div className="footer-socials text-center py-1">
          {socialLinks.facebook && (
            <a href={socialLinks.facebook} className="social-icon" aria-label="facebook" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-facebook"></i>
            </a>
          )}
          {socialLinks.linkedin && (
            <a href={socialLinks.linkedin} className="social-icon" aria-label="linkedin" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-linkedin"></i>
            </a>
          )}
          {socialLinks.instagram && (
            <a href={socialLinks.instagram} className="social-icon" aria-label="instagram" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-instagram"></i>
            </a>
          )}
        </div>

        <div className="footer-bottom text-center mt-4 small text-muted">
          <div>© 2024 SocialManiacs. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
